<template>
  <div class="mod-rm__courseclassroomrela">
    <div style="margin-top: 5px;">
      <el-row :gutter="10">
        <el-col :span="18">
          <el-tabs v-model="choseType" type="border-card" class="mod-rm-courseclassroomrela-tab">
            <el-tab-pane :label="$t('res.coursetrainerrela.roomChose')" name="0">
              <!--查询教室-->
              <el-row>
                <el-col :span="24">
                  <div ref="queryBox"
                      class="queryBox">
                    <el-form :label-position="labelPosition"
                              :label-width="queryLabelWidth"
                              :model="dataForm"
                              class="classroomPool-search-condition">
                      <el-row :gutter="0">
                          <el-col :span="6">
                            <!-- 教室编号 -->
                            <el-form-item class="popup-one-classroom" :label="$t('res.courseclassroomrela.classroom')">
                              <el-input v-model="dataForm.classroomNo"
                                      clearable
                                      :placeholder="$t('res.courseclassroomrela.classroomPlaceholder')"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <!-- 教室分类 -->
                            <el-form-item class="popup-one-classroomclassification" prop="classroomClassList"
                                          :label="$t('res.courseclassroomrela.classroomClass')">
                              <class-tree ref="classroomclassRef"
                                          v-on:getSelectList="getClassroomList"
                                          v-bind:defaultProps="classroomProps"
                                          v-bind:url="queryclassroomUrl"
                                          v-bind:isSelect=false
                                          style="width:99%;"></class-tree>
                            </el-form-item>
                          </el-col>
                          <!-- 教室标签 -->
                          <el-col :span="6">
                            <el-form-item class="search-item popup-one-classroomlabel" style="height: 34px;">
                              <span slot="label">
                                <el-link type="primary" :underline="false" slot="reference"
                                          @click.native.prevent="showSuboLableDlg">{{ $t('res.courseclassroomrela.classroomLabel')}}</el-link>
                              </span>
                              <div class="el-input el-input--default el-input__inner" style="height:30px;" @mouseenter="classroomLabelShow()" @mouseleave="classroomLabelLeave()" >
                                <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.classroomLabelName}}</div>
                                <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="classroomLabelLink" v-show="classroomLabelShowFlg && dataForm.classroomLabelName != '' && dataForm.classroomLabelName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="clearclassroomLabelName()"></el-link>
                              </div>
                            </el-form-item>
                          </el-col>
                          <el-col :span="3">
                            <el-form-item>
                              <el-button class="M-search" type="primary" @click="queryClassroomInfo()">{{ $t('query') }}</el-button>
                            </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="0">
                          <el-col :span="6">
                            <!--所属城市-->
                            <el-form-item class="popup-two-city" :label="$t('res.courseclassroomrela.city')" prop="cityList">
                              <class-tree ref="cityclassRef"
                                          v-on:getSelectList="getCitySelectList"
                                          v-bind:defaultProps="citydefaultProps"
                                          v-bind:isOpen=false
                                          v-bind:url="queryCityTreeUrl"
                                          v-bind:isSelect=false></class-tree>
                            </el-form-item>
                          </el-col>
                          <!--所属场地-->
                          <el-col :span="6">
                            <el-form-item class="search-item popup-two-site">
                              <span slot="label">
                                <el-link type="primary" :underline="false" slot="reference"
                                          @click.native.prevent="showSuboSiteDlg">{{ $t('res.courseclassroomrela.classification')}}</el-link>
                              </span>
                              <div class="el-input el-input--default el-input__inner" style="height:30px;" @mouseenter="templateNameLinkShow()" @mouseleave="templateNameLinkLeave()">
                                <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.subordinateSiteName}}</div>
                                <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="templateNameLink" v-show="templateNameLinkShowFlg && dataForm.subordinateSiteName != '' && dataForm.subordinateSiteName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="clearTemplateName()"></el-link>
                              </div>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">&nbsp;
                          </el-col>
                          <el-col :span="3">
                            <el-form-item>
                              <el-button class="el-back M-search M-margin-l" type="info" @click="resetQuery()">{{ $t('reset') }}</el-button>
                            </el-form-item>
                          </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </el-col>
              </el-row>
              <!-- 数据网格 -->
              <div class="dataBox">
                <el-table border
                          ref="selectClassroominfo"
                          :data="dataList"
                          v-loading="dataListLoading"
                          size="mini"
                          stripe
                          @select="selectRedio"
                          @select-all="selectAllRedio">
                  <el-table-column type="selection"
                                  header-align="center"
                                  align="center"
                                  width="50"
                                  :selectable='checkboxT'>
                  </el-table-column>
                  <el-table-column prop="xh"
                                  fixed
                                  :label="$t('res.courseclassroomrela.serialNo')"
                                  type="index"
                                  min-width="55"
                                  header-align="center"
                                  align="center" />
                  <template v-for="item in columnList">
                    <el-table-column :prop="item.prop"
                                      :key="item.prop"
                                      v-if="item.prop!=='classroomTag'"
                                      header-align="center"
                                      align="center"
                                      :width="item.width"
                                      show-overflow-tooltip
                                      :label="item.label">
                    </el-table-column>
                    <el-table-column prop="classroomTag"
                                    header-align="center"
                                    align="center"
                                    :key="item.prop"
                                    v-else
                                    show-overflow-tooltip
                                    :label="$t('res.courseclassroomrela.classroomTag')">
                      <template slot-scope="scope">
                        <span class="el-dropdown-link"
                              v-if="scope.row.numberLaber !== null"
                              @click="checkLable(scope.row)">{{ $t('view') }}</span>
                      </template>
                    </el-table-column>
                  </template>
                </el-table>
                <el-pagination @size-change="pageSizeChangeHandle"
                              @current-change="pageCurrentChangeHandle"
                              :current-page="page"
                              :page-sizes="[10, 20, 50, 100]"
                              :page-size="limit"
                              layout="total, sizes, prev, pager, next, jumper"
                              :total="total">
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('res.coursetrainerrela.baseCourseRoomChose')" name="1">
              <div class="rm-room-chose-li clearfix">
                <div class="chose-li-module clearfix">
                  <span class="module-name">{{ $t('res.coursetrainerrela.courseNameCode') }}</span>
                  <span class="module-value module-value2">
                   <el-select
                      v-model="courseNameCode"
                      filterable
                      remote
                      reserve-keyword
                      clearable
                      :placeholder="$t('res.coursetrainerrela.courseNameCode')"
                      :remote-method="remoteMethod"
                      :loading="loading">
                      <el-option
                        v-for="(item,index) in options"
                        :key="'course'+index"
                        :label="item.courseCode +'-'+item.courseNameCn"
                        :value="item.courseCode">
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div class="chose-li-module clearfix">
                  <el-button style="display: inline;"
                                  class="search"
                                  type="primary"
                                  size="mini"
                                  @click="searchClassRoom">{{ $t('res.courseclassroomrela.determine') }}</el-button>
                </div>
                <div class="chose-li-module chose-li-module2 clearfix" v-if="roomShow">
                  <span class="module-name">{{ $t('res.coursetrainerrela.room') }}</span>
                  <span class="module-value">
                    <el-select v-model="dataForms.trainerPool"
                              @change="setPoolClass(dataForms.trainerPool)">
                      <el-option v-for="(item,index) in trainerPool"
                                  :key="index"
                                  :label="$t('res.coursetrainerrela.room')+(index+1)"
                                  :value="item.poolId">
                      </el-option>
                    </el-select>
                  </span>
                </div>
              </div>
              <!-- 数据网格 -->
              <div class="dataBox">
                <el-table border
                          ref="selectClassroominfo2"
                          :data="dataList2"
                          v-loading="dataListLoading2"
                          size="mini"
                          stripe
                          style="width: 100%;"
                          @select="selectRedio"
                          @select-all="selectAllRedio">
                  <el-table-column type="selection"
                                  header-align="center"
                                  align="center"
                                  width="50"
                                  :selectable='checkboxT'>
                  </el-table-column>
                  <el-table-column prop="xh"
                                  fixed
                                  :label="$t('res.courseclassroomrela.serialNo')"
                                  type="index"
                                  min-width="55"
                                  header-align="center"
                                  align="center" />
                  <template v-for="item in columnList">
                    <el-table-column :prop="item.prop"
                                      :key="item.prop"
                                      v-if="item.prop!=='classroomTag'"
                                      header-align="center"
                                      align="center"
                                      :width="item.width"
                                      show-overflow-tooltip
                                      :label="item.label">
                    </el-table-column>
                    <el-table-column prop="classroomTag"
                                    header-align="center"
                                    align="center"
                                    :key="item.prop"
                                    v-else
                                    show-overflow-tooltip
                                    :label="$t('res.courseclassroomrela.classroomTag')">
                      <template slot-scope="scope">
                        <span class="el-dropdown-link"
                              v-if="scope.row.numberLaber !== null"
                              @click="checkLable(scope.row)">{{ $t('view') }}</span>
                      </template>
                    </el-table-column>
                  </template>
                </el-table>
                <el-pagination @size-change="pageSizeChangeHandle2"
                              @current-change="pageCurrentChangeHandle2"
                              :current-page="pageNumber2"
                              :page-sizes="[10, 20, 50, 100]"
                              :page-size="pageSize2"
                              layout="total, sizes, prev, pager, next, jumper"
                              :total="total2">
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <!--已选教室-->
        <el-col :span="6">
          <el-card>
            <div v-if="choseType==='0'">
              <el-form :model="dataForms"
                       :rules="dataRule"
                       ref="dataForms"
                       label-position="left">
                <div class="location-layout22">
                  <el-row>
                    <!-- 优先级 -->
                    <el-col :span="18">
                      <el-form-item :label="$t('res.courseclassroomrela.priority')">
                        <!-- 被覆盖之后抢回来 -->
                        <el-select size="mini"
                                   v-model="dataForms.priority"
                                   clearable
                                   style="width: 100px !important;">
                          <el-option v-for="(item,index) in priorityArr"
                                     :key="index"
                                     :label="item.name"
                                     :value="item.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-button style="display: inline;"
                                 class="search"
                                 type="primary"
                                 size="mini"
                                 @click="onOk">{{ $t('res.courseclassroomrela.determine') }}</el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
            <div v-else style="text-align:right">
              <el-button style="display: inline;"
                          class="search"
                          type="primary"
                          size="mini"
                          @click="onOk2">{{ $t('res.courseclassroomrela.determine') }}</el-button>
            </div>
          </el-card>
          <el-card class="box-card">
            <div>
              <span class="dataBox">{{$t('res.courseclassroomrela.selected')}}</span>
              <div>
                <el-row :gutter="10">
                  <el-col v-for="tag in classroomData"
                          :key="tag.classroomNo">
                    <el-tag show-overflow-tooltip
                            style="margin-bottom: 10px;width: 250px"
                            :key="tag.classroomNo"
                            @close="handleClose(tag)"
                            closable>{{tag.classroomNo}}</el-tag>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- 所属场地dialog -->
    <subordinate-site ref="suborSiteRef"
                      :isSingleElection='false'
                      :isShow='false'
                      :isQueryShow="true"
                      v-bind:selectTable="selectSite"
                      v-bind:statusList="statusList"
                      :dialogVisible="isShowSuboSite"
                      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
                      v-on:bringBack="bringBack"></subordinate-site>
    <!--标签查询条件-->
    <el-dialog title="选择标签"
              :visible="isQueryShowLable"
              width="70%"
              append-to-body
              :before-close="showQueryLableClose">
      <el-form label-position="top"
              label-width="150px"
              :ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                    :moduleId="moduleId"
                    :overLabelShow = "true"
                    :closeShow = "true"
                    :bussinessTypeId = "bussinessTypeId"
                    :brandCode="bussinessTypeChecked"
                    @getBussinessType="getBussinessType"
                    @changeCheckedList="changeCheckedList"
                    ref='tagTree'
                    @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div>
        <el-button type="primary"
                  @click="onOkLable">{{ $t('res.rela.determine') }}</el-button>
      </div>
    </el-dialog>
    <!-- 标签查看 -->
    <el-dialog title="标签查看"
              :visible="isShowLable"
              width="70%"
              append-to-body
              :before-close="showLableClose">
      <el-form label-position="top"
              label-width="150px"
              :ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="showcheckList"
                    :moduleId="moduleId"
                    :overLabelShow = "false"
                    :closeShow = "false"
                    :bussinessTypeId = "bussinessTypeId"
                    :brandCode="bussinessTypeChecked"
                    @getBussinessType="getBussinessType"
                    @changeCheckedList="changeShowCheckedList"
                    ref='tagTree'
                    @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import ClassTree from '@/components/rm/class-tree/index'
import subordinateSite from '@/components/rm/resources-site/index'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'
import Vue from 'vue'
export default {
  props: {
    classroomInfoList: {
      type: Array,
      required: false
    },
    isSelectElection: {
      type: Boolean,
      default: false
    },
    selectTable: {
      type: Array,
      required: false
    }
  },
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/rm/courseclassroomrela/queryClassroomlist',
        getDataListIsPage: true,
        deleteURL: '/rm/courseclassroomrela/delete',
        deleteIsBatch: true,
        exportURL: '/rm/courseclassroomrela/export'
      },
      dataForm: {
        classroomNo: '',
        classRoomStatus: '',
        classroomLabel: '',
        classroomLabelName: '',
        classroomClassList: [],
        cityList: [],
        classificationList: []
      },
      dataForms: {
        priority: '',
        trainerPool: []
      },
      trainerPool: [],
      dataFormHold: {
        classRoomStatusArr: [],
        classificationListArr: []
      },
      isQueryShowLable: false,
      isShowLable: false,
      checkList: [],
      showcheckList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 10,
      bussinessTypeChecked: 10,
      isShowSuboSite: false,
      selectSite: [],
      statusList: ['10'],
      // 已选教室
      classroomData: [],
      classroomInfo: {},
      statusArr: this.enums['status'], // 状态下拉框
      priorityArr: this.enums['priority'], // 优先级
      siteInfoArr: [
        { code: '112', name: '东莞庆宝' },
        { code: '113', name: '艾仕得成都培训中心' },
        { code: '114', name: '东营广宝' },
        { code: '115', name: '北京培训中心（新）' },
        { code: '116', name: '郑州培训基地' },
        { code: '117', name: '测试场地001' }
      ], // 所属场地
      dataListLoading: false,
      // 教室分类
      classroomProps: {
        children: 'children',
        label: 'roomClassCnName'
      },
      queryclassroomUrl: '/rm/courseclassroomrela/courseClassroomTreeRela',
      // 城市分类
      citydefaultProps: {
        children: 'childrenRegionList',
        label: 'regionNameCn'
      },
      queryCityTreeUrl: '/rm/courseclassroomrela/queryregiontree',
      // 标签树
      commLabelProps: {
        children: 'children',
        label: 'labelNameCn'
      },
      querycommLabelUrl: '/rm/courseclassroomrela/queryCommLabelNodeByNameRela',
      // 场地分类
      // classificationProps: {
      //   children: 'children',
      //   label: 'siteClassCnName'
      // },
      // queryClassificationTreeUrl: '/rm/siteclass/list',
      // 编辑面板标签对齐方式
      labelPosition: 'left',
      // 查询面板标签宽度
      queryLabelWidth: 'auto',
      classroomLabelList: [], // 标签,
      templateNameLinkShowFlg: false,
      classroomLabelShowFlg: false,
      dataRule: {
        priority: [
          { required: true, message: this.$t('res.courseclassroomrela.priorityCheck'), trigger: 'blur' }
        ]
      },
      choseType: '0',
      columnList: [
        { prop: 'classroomNo', label: this.$t('res.courseclassroomrela.classroomNo') },
        { prop: 'classroomName', label: this.$t('res.courseclassroomrela.classroomName'), width: 160 },
        { prop: 'classroomClass', label: this.$t('res.courseclassroomrela.classroomClass') },
        { prop: 'city', label: this.$t('res.courseclassroomrela.city') },
        { prop: 'classification', label: this.$t('res.courseclassroomrela.classification') },
        { prop: 'classroomTag', label: this.$t('res.courseclassroomrela.classroomTag') },
        { prop: 'annual', label: this.$t('res.courseclassroomrela.annual') },
        { prop: 'reportAnnualTarget', label: this.$t('res.courseclassroomrela.reportAnnualTarget') },
        { prop: 'roomArea', label: this.$t('res.courseclassroomrela.roomArea') },
        { prop: 'maxNo', label: this.$t('res.courseclassroomrela.maxNo') },
        { prop: 'floor', label: this.$t('res.courseclassroomrela.floor') },
        { prop: 'liftNo', label: this.$t('res.courseclassroomrela.liftNo'), width: 120 },
        { prop: 'workplaceNo', label: this.$t('res.courseclassroomrela.workplaceNo') }
      ],
      roomShow: false,
      courseNameCode: '',
      dataList2: [],
      dataListLoading2: false,
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      options: [],
      loading: false
    }
  },
  components: {
    Tag,
    'class-tree': ClassTree,
    'subordinate-site': subordinateSite
  },
  mounted () {
    this.initMethods()
  },
  watch: {
    choseType () {
      this.dataForm = {
        classroomNo: '',
        classRoomStatus: '10',
        classroomLabel: '',
        classroomLabelName: '',
        classroomClassList: '',
        cityList: '',
        classificationList: ''
      }
      this.dataForms = {
        priority: '',
        traninerPool: ''
      }
      this.courseNameCode = ''
      this.checkList = []
      this.classroomData = []
      this.dataList2 = []
      this.roomShow = false
      this.total2 = 0
      this.$refs.selectClassroominfo.clearSelection()
      this.$refs.selectClassroominfo2.clearSelection()
    }
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.$request.get(`/learning/courseinfo/page?coursename	=${query}&page=1&limit=20`).then((res) => {
            if (res) {
              this.options = res.records || []
              this.loading = false;
            }
          })
        }, 100);
      } else {
        this.options = [];
      }
    },
    // 点击选择标签打开弹窗
    showSuboLableDlg () {
      this.isQueryShowLable = true
    },
    //关闭选择标签弹窗
    showQueryLableClose(){
      this.isQueryShowLable = false
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    onOkLable(){
      let args = this.checkList
      if (args && args !== '' && args.length > 0) {
        let classLabelinfo = []
        let classLabelinfoName = []
        args.forEach(function (item) {
          classLabelinfo.push(item.labelId)
          classLabelinfoName.push(item.labelName)
        })
        this.dataForm.classroomLabel = classLabelinfo.join(',')
        this.dataForm.classroomLabelName = classLabelinfoName.join(',')
      } else {
        this.dataForm.classroomLabel = ''
        this.dataForm.classroomLabelName = ''
      }
      this.isQueryShowLable = false
    },
    // 获取数据列表
    getDataList () {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        console.log(res)
        this.dataListLoading = false
        let resultList = data.data.records
        // this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? data.result.list : resultList
        this.dataList = resultList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
        // 延迟加载
        this.$nextTick(() => {
          this.querSelect()
        })
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.classStatus, 'status')
    },
    initMethods () {
      this.dataForm = {
        classroomNo: '',
        classRoomStatus: '10',
        classroomLabel: '',
        classroomClassList: '',
        cityList: '',
        classificationList: ''
      }
      this.dataForms = {
        priority: ''
      }
      this.dataFormHold = {
        classRoomStatusArr: []
      }
      this.$refs.classroomclassRef.resetChecked()
      this.$refs.cityclassRef.resetChecked()
      this.page = 1
      this.getDataList()
      this.classroomData = []
      this.checkList = []
      this.templateNameLinkShowFlg = false
      this.classroomLabelShowFlg = false
      this.$request.get(`/rm/courseclassroomrela/queryBussinessTypeIdRela`).then((res, total, code, data) => {
        if (data.data != null && data.data != undefined) {
          this.bussinessTypeId = data.data
          this.bussinessTypeChecked = data.data
        }
      })
    },
    selectRedio (selection, row) {
      let result = selection.filter((item) => { return item.classroomNo===row.classroomNo })
      if (result.length > 0) {
        for(let item of this.classroomInfoList) {
          if (item.classroomNo === row.classroomNo) {
            this.$message.warning(this.$t('res.coursetrainerrela.ondb'))
            this.$refs.selectClassroominfo.toggleRowSelection(row, false)
            this.$refs.selectClassroominfo2.toggleRowSelection(row, false)
            return false
          }
        }
        this.classroomData.push(row)
      } else {
        for(let [index,value] of this.classroomData.entries()) {
          if (row.classroomNo === value.classroomNo) {
            this.classroomData.splice(index, 1);
            break;
          }
        }
      }
    },
    // 控制可选项
    checkboxT (row) {
      let checkFlgArr = []
      if (this.classroomInfoList && this.classroomInfoList.length > 0) {
        checkFlgArr = this.classroomInfoList.filter((item) => { return row.classroomNo === item.classroomNo })
      }
      return checkFlgArr.length === 0
    },
    // 全选
    selectAllRedio (selection) {
      let classRooms = this.classroomData.map((item) => { return item.classroomNo }) || []
      if (selection.length > 0) {
        for (let item of selection) {
          if(!classRooms.includes(item.classroomNo)) {
            this.classroomData.push(item)
          }
        }
      } else {
        this.classroomData = []
      }
    },
    // 确认
    onOk () {
      let priority = this.dataForms.priority
      this.$refs['dataForms'].validate((valid) => {
        if (valid) {
          let classroomData = this.classroomData
          if (!priority) {
            this.$message.warning(this.$t('res.courseclassroomrela.selectPriority'))
            return false
          }
          if (classroomData.length <= 0) {
            this.$message.warning(this.$t('res.courseclassroomrela.selectCheck'))
            return false
          }
          let _this = this
          classroomData.forEach(function (item) {
            item['priority'] = _this.dataForms.priority
          })
          _this.$emit('onOk', classroomData)
          _this.$refs.selectClassroominfo.clearSelection()
        }
      })
    },
    // 确认
    onOk2 () {
      // 如果没有新增的
      let classroomData = this.classroomData
      if (classroomData.length <= 0) {
        this.$message.warning(this.$t('res.courseclassroomrela.selectRoomCheck'))
        return false
      }
      this.$emit('onOk', classroomData)
      this.$refs.selectClassroominfo2.clearSelection()
    },
    // 重置查询条件
    resetQuery () {
      this.dataForm = {
        classroomNo: '',
        classRoomStatus: '10',
        classroomLabel: '',
        classroomLabelName: '',
        classroomClassList: '',
        cityList: '',
        classificationList: ''
      }
      this.dataFormHold = {
        classRoomStatusArr: [],
        classificationListArr: []
      }
      this.limit = 10
      this.page = 1
      this.$refs.classroomclassRef.resetChecked()
      this.$refs.cityclassRef.resetChecked()
      this.checkList = []
      this.queryClassroomInfo()
    },
    getClassroomList (args) {
      let classroominfo = []
      args.forEach(function (item) {
        classroominfo.push(item.id)
      })
      this.dataForm.classroomClassList = classroominfo.join(',')
    },
    getCitySelectList (args) {
      if (args && args !== '' && args.length > 0) {
        let citySelect = []
        args.forEach(function (item) {
          citySelect.push(item.id)
        })
        this.dataForm.cityList = citySelect.join(',')
      } else {
        this.dataForm.cityList = ''
      }
    },
    getClassificationList (args) {
      if (args && args !== '' && args.length > 0) {
        let siteClass = []
        args.forEach(function (item) {
          siteClass.push(item.id)
        })
        this.dataForm.siteClassList = siteClass.join(',')
      } else {
        this.dataForm.siteClassList = ''
      }
    },
    // 双击选择教室数据
    onDbClassroom (val) {
      if (val) {
        if (this.classroomData) {
          for(let item of this.classroomData) {
            if (item.classroomId === val.classroomId) {
              this.$message.warning(this.$t('res.courseclassroomrela.ondb'))
              return false
            }
          }
        }
        this.classroomData.push(val)
      }
    },
    // 打开页面时，回填勾选
    querSelect () {
      if (this.classroomData && this.classroomData.length > 0) {
        var map = new Map()
        this.classroomData.forEach( (item) => {
          map.set(String(item.classroomNo), item)
        })
        if (this.dataList2.length > 0) {
          this.dataList2.forEach((dataitem) => {
            if (map.has(String(dataitem.classroomNo))) {
              this.$refs.selectClassroominfo2.toggleRowSelection(dataitem)
            }
          })
        } else {
          this.dataList.forEach( (dataitem) => {
            if (map.has(String(dataitem.classroomNo))) {
              this.$refs.selectClassroominfo.toggleRowSelection(dataitem)
            }
          })
        }
      }
    },
    // 删除已选备件
    handleClose (data) {
      if (this.choseType === '0') {
       for (let item of this.dataList) {
          if (item.classroomNo === data.classroomNo) {
            this.$refs.selectClassroominfo.toggleRowSelection(item, false)// 选择当前行
            break
          }
        }
      } else {
        for (let item of this.dataList2) {
          if (item.classroomNo === data.classroomNo) {
            this.$refs.selectClassroominfo2.toggleRowSelection(item, false)// 选择当前行
            break
          }
        }
      }
      this.classroomData.splice(this.classroomData.indexOf(data), 1)
    },
    queryClassroomInfo () {
      this.page = 1
      this.getDataList()
    },
    // 关闭所属场地
    closeSuboSiteDlg () {
      this.isShowSuboSite = false
    },
    // 点击所属场地确定带回
    bringBack (selection) {
      let siteNames = []
      let siteIds = []
      selection.forEach(item => {
        siteNames.push(item.siteCnName)
        siteIds.push(item.id)
      })
      if (selection && selection.length > 0) {
        this.dataForm.classificationList = siteIds.join(',')
        this.dataForm.subordinateSiteName = siteNames.join(',')
      } else {
        this.dataForm.classificationList = ''
        this.dataForm.subordinateSiteName = ''
      }
      this.isShowSuboSite = false
      this.selectSite = selection
    },
    celarSiteName () {
      this.selectSite = []
      this.dataForm.classificationList = ''
      this.dataForm.subordinateSiteName = ''
    },
    // 点击所属场地打开弹窗
    showSuboSiteDlg () {
      this.isShowSuboSite = true
      this.$refs.suborSiteRef.initSuborSite()
    },
    // 获取教室标签
    getClassroomLabelList (args) {
      if (args && args !== '' && args.length > 0) {
        let classroomLabelinfo = []
        args.forEach(function (item) {
          classroomLabelinfo.push(item.id)
        })

        this.dataForm.classroomLabel = classroomLabelinfo.join(',')
      } else {
        this.dataForm.classroomLabel = ''
      }
    },
    clearSuboSiteDlg () {
      this.dataForm.classificationList = ''
    },
    clearTemplateName () {
      this.selectTable = []
      this.dataForm.classificationList = ''
      this.dataForm.subordinateSiteName = ''
      this.templateNameLinkShowFlg = false
    },
    templateNameLinkShow () {
      this.templateNameLinkShowFlg = true
    },
    templateNameLinkLeave () {
      this.templateNameLinkShowFlg = false
    },
    checkLable(row){
      this.isShowLable = true
      this.$request.get(`/rm/courseclassroomrela/queryCheckedCommLabel/${row.classroomId}/${this.bussinessTypeId}`).then((data) => {
        // 已选择的标签
        this.showcheckList = data ? data : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          this.showcheckList.forEach(o => {
            o.labelName = o.labelNameCn
          })
        } else {
          this.showcheckList.forEach(o => {
            o.labelName = o.labelNameEn
          })
        }
      })
    },
    showLableClose(){
      this.showcheckList = []
      this.isShowLable = false
    },
    clearclassroomLabelName () {
      this.dataForm.classroomLabel = ''
      this.dataForm.classroomLabelName = ''
      this.checkList = []
      this.classroomLabelShowFlg = false
    },
    classroomLabelShow () {
      this.classroomLabelShowFlg = true
    },
    classroomLabelLeave () {
      this.classroomLabelShowFlg = false
    },
    getBussinessType (val) {
      this.bussinessTypeId = val
    },
    changeShowCheckedList (array) {
      this.showcheckList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameCn
        })
      } else {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameEn
        })
      }
    },
    pageSizeChangeHandle2 (val) {
      this.pageSize2 = val
      this.pageNumber2 = 1
      this.getPoolClass(this.dataForms.trainerPool)
    },
    pageCurrentChangeHandle2 (val) {
      this.pageNumber2 = val
      this.getPoolClass(this.dataForms.trainerPool)
    },
    searchClassRoom () {
      this.dataList2 = []
      if(!this.courseNameCode) {
        this.roomShow = false
        this.dataList2 = []
        this.classroomData = []
        this.total2 = 0
        this.pageSize2 = 10
        this.pageNumber2 = 1
        this.$message({
          message: this.$t('course.courseNameCode'),
          type: 'warning',
          duration: 500
        })
        return false
      }
      this.$request.post('/rm/courseclassroomrela/classroomPoolList', { param: this.courseNameCode }).then((res) => {
        if(res) {
          this.trainerPool = res.map((item)=> {
            return { poolId: item.poolId, poolName: item.poolName, courseId: item.courseId }
          })
          this.dataForms.trainerPool = this.trainerPool[0].poolId
          this.roomShow = true
          this.getPoolClass(this.dataForms.trainerPool)
        }
      }).catch(()=> {
        this.dataList2 = []
        this.courseNameCode = ''
        this.classroomData = []
        if (this.selectTable && this.selectTable.length > 0) {
          this.classroomData = this.selectTable
        }
        this.roomShow = false
        this.total2 = 0
        this.pageSize2 = 10
        this.pageNumber2 = 1
      })
    },
    setPoolClass (val) {
      this.classroomData = []
      if (this.selectTable && this.selectTable.length > 0) {
        this.classroomData = this.selectTable
      }
      this.getPoolClass(val)
    },
    getPoolClass (val) {
      let courseId = ''
      this.dataListLoading2 = true
      this.dataList2 = []
      this.trainerPool.forEach((item) => {
        if(item.poolId===val){
          courseId = item.courseId
        }
      })
      this.$request.get(`/rm/courseclassroomrela/poolClassroomList?courseId=${courseId}&poolId=${val}&page=${this.pageNumber2}&limit=${this.pageSize2}`).then((res) => {
        if(res) {
          this.dataListLoading2 = false
          this.total2 = res.total
          this.dataList2 = res.records
          this.$nextTick(() => {
            this.querSelect()
          })
        }
      }).catch(() => {
        this.dataListLoading2 = false
      })
    },
  },
  beforeDestroy() {
    this.classroomData= []
    this.checkList = []
    this.courseNameCode = ''
    this.dataForm = {
      classroomNo: '',
      classRoomStatus: '10',
      classroomLabel: '',
      classroomLabelName: '',
      classroomClassList: '',
      cityList: '',
      classificationList: ''
    }
    this.dataList2 = []
    this.total2 = 0
    this.dataForms = {
      priority: '',
      traninerPool: ''
    }
    this.roomShow = false
    this.total2 = 0
    this.$refs.selectClassroominfo.clearSelection()
    this.$refs.selectClassroominfo2.clearSelection()
  },
}
</script>
<style lang="scss" scoped>
.location-layout22 .el-input {
  width: 80px !important;
}
.location-layout22 .el-input__inner {
  width: 80px !important;
}
.link-delete-temp:hover{
  cursor: pointer;
  text-decoration: none !important;
}
.holder:empty::before{
  color:#bbb;
  content:attr(placeholder);
}
.classroomPool-search-condition .el-form-item__content{
  margin-left: 68px !important;
}
.popup-one-classroom, .popup-one-classroomclassification, .popup-two-site, .popup-one-classroomlabel, .popup-two-city {
  width: 90% !important;
}
.popup-one-classroom .el-form-item__content {
  /* width: 90% !important; */
  margin-left: 90px !important;
}
/* .popup-one-classroom .el-form-item__content {
  margin-left: 90px !important;
} */
.popup-one-classroomclassification .el-form-item__content, .popup-two-site .el-form-item__content {
  margin-left: 90px !important;
}
.popup-one-classroomlabel .el-form-item__content, .popup-two-city .el-form-item__content {
  margin-left: 90px !important;
}
.rm-room-chose-li{
  color: #606266;
  line-height: 32px;
  margin-bottom: 10px;
  .chose-li-module{
    margin-right: 10px;
    float: left;
    &.chose-li-module{
      margin-left: 20px;
    }
    .module-name{
      display: block;
      float: left;
      margin-right: 12px;
      text-align: right;
    }
    .module-value{
      display: block;
      float: left;
    }
  }
}
</style>
<style lang="scss">
.rm-room-chose-li {
  .module-value2 {
    .el-select {
      .el-input .el-input__inner{
        cursor: text !important;
      }
    }
  }
}
</style>
